const currentYear = new Date().getFullYear();

const locale = {
    code: "de",
    label: "Deutsch",
    NAV_BAR: {
        home: "Startseite",
        homeId: "home",
        aboutus: "Über uns",
        aboutId: "aboutus",
        faq: "FAQ",
        faqId: "faq-section",
        contact: "Kontakt",
        contactId: "contact-section",
        button: "Frühen Zugriff",
    },

    HERO: {
        heroHeading: "Ihr Menü, sofort zugänglich",
        heroParagraph:
            "Erstellen, aktualisieren und teilen Sie Ihr Menü mit einem einzigen QR-Code — kein Aufwand, kein Nachdruck.",
        button: "Frühen Zugriff",
        downloadText: "Herunterladen auf",
        appStore: "App Store",
        getItOn: "HOL ES DIR AUF",
        googlePlay: "Google Play",
    },

    SERVICES: {
        heading: "Unsere Services",
        cards: [
            {
                title: "Menü erstellen und hochladen",
                description:
                    "Erstellen und laden Sie Ihr Menü ganz einfach mit nur wenigen Klicks hoch! Fügen Sie Elemente hinzu, legen Sie Preise fest und aktualisieren Sie Details ohne technische Kenntnisse.",
            },
            {
                title: "Menü aktualisieren",
                description:
                    "Aktualisieren Sie Ihr Menü jederzeit in Echtzeit! Ändern Sie Preise, fügen Sie neue Gerichte hinzu oder archivieren Sie nicht verfügbare Artikel sofort ohne Nachdruck.",
            },
            {
                title: "Generieren und teilen",
                description:
                    "Generieren Sie sofort einen eindeutigen QR-Code für Ihr Menü! Teilen Sie ihn auf Tischen, Postern oder online, damit Kunden Ihr aktuelles Menü abrufen können.",
            },
        ],
    },

    FEATURES: {
        heading: "Entdecken Sie unsere großartigen Funktionen",
        lists: [
            {
                title: "Menü verwalten",
                description:
                    "Verwalten Sie Ihr Menü jederzeit! Fügen Sie einfach Elemente hinzu, bearbeiten oder entfernen Sie sie, um Ihr Angebot aktuell zu halten.",
            },
            {
                title: "Einblicke & Berichte",
                description:
                    "Erhalten Sie wertvolle Erkenntnisse mit Echtzeitberichten! Verfolgen Sie Menüsichtungen, QR-Code-Scans und Kundeninteraktionen.",
            },
            {
                title: "QR-Codes teilen",
                description:
                    "Teilen Sie Ihr Menü mit einem einzigartigen QR-Code! Präsentieren Sie ihn auf Tischen, Postern oder online, damit Kunden ihn sofort scannen können.",
            },
            {
                title: "Kundenbewertungen",
                description:
                    "Präsentieren Sie echtes Kundenfeedback und Bewertungen! Bauen Sie Vertrauen auf, verbessern Sie Ihr Menü und optimieren Sie das Gastronomieerlebnis.",
            },
            {
                title: "Angebote & Rabatte",
                description:
                    "Steigern Sie den Umsatz mit Sonderangeboten und Rabatten! Heben Sie zeitlich begrenzte Aktionen und exklusive Rabatte hervor.",
            },
        ],
    },

    ABOUT: {
        heading: "Über My QR Menu",
        headingPara: "Vereinfachen Sie die Verwaltung Ihrer Restaurantkarte mit Echtzeit-Updates.",
        highlightHeading: "Schneller, einfacher Zugriff auf alles, was Sie brauchen",
        highlightPara: "Alle Ihre Menüfunktionen — nur mit einer Berührung.",
        cards: {
            left: {
                heading: ["Fügen Sie Zutaten einfach hinzu", "zu Ihrem QR-Menü"],
                alt: "Zutaten hinzufügen",
            },
            right: {
                heading: ["Greifen Sie einfach auf", "Ihr Menü-Dashboard zu"],
                alt: "Menü-Dashboard",
            },
        },
    },

    FAQ: {
        heading: "Sie haben Fragen. Wir haben Antworten.",
        subheading: "Alles, was Sie über das Produkt wissen müssen.",
        items: [
            {
                question: "Was ist My QRMenu?",
                answer:
                    "My QRMenu ist eine digitale Menüplattform, mit der Restaurants ihre Menüs sofort mithilfe von QR-Codes erstellen, aktualisieren und teilen können.",
            },
            {
                question: "Kann ich mein Menü nach der Erstellung aktualisieren?",
                answer:
                    "Ja, Sie können Ihr Menü jederzeit aktualisieren und es wird sofort angezeigt, wenn Kunden Ihren QR-Code scannen.",
            },
            {
                question: "Wie funktioniert My QRMenu?",
                answer:
                    "Sie erstellen ein Menü, generieren einen QR-Code und Kunden scannen ihn, um die neueste Version Ihres Menüs anzuzeigen.",
            },
            {
                question: "Wie teile ich meinen QR-Code?",
                answer:
                    "Sie können Ihren QR-Code digital teilen oder ihn zum Ausstellen in Ihrem Restaurant drucken.",
            },
            {
                question: "Ist My QRMenu mobilfreundlich?",
                answer:
                    "Ja, My QRMenu ist für alle Geräte optimiert, einschließlich Smartphones und Tablets.",
            },
            {
                question: "Kann ich Kundenbewertungen sammeln?",
                answer:
                    "Ja, Sie können Kundenbewertungen aktivieren und das Feedback zur Verbesserung Ihres Angebots nutzen.",
            },
        ],
    },

    CONTACT: {
        heading: "Kontaktieren Sie uns",
        subheading: "Unser freundliches Team hört gerne von Ihnen.",
        firstName: "Vorname",
        lastName: "Nachname",
        email: "E-Mail",
        message: "Nachricht",
        firstNamePlaceholder: "Vorname",
        lastNamePlaceholder: "Nachname",
        emailPlaceholder: "du@firma.com",
        messagePlaceholder: "Schreiben Sie Ihre Nachricht...",
        privacyConsent: "Sie stimmen unserer",
        privacyPolicy: "Datenschutzrichtlinie",
        submitButton: "Nachricht senden",
        toast: {
            requiredConsent: "Sie müssen der Datenschutzrichtlinie zustimmen.",
            submitting: "Nachricht wird gesendet...",
            success: "Nachricht erfolgreich gesendet!",
            fail: "Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
            error: "Ein Fehler ist aufgetreten. Bitte überprüfen Sie Ihre Verbindung.",
        },
    },

    HELP_PAGE: {
        title: "Hilfecenter",
        description: "Wenn Sie Fragen haben oder Unterstützung benötigen, kontaktieren Sie uns unter ",
        contactEmail: "contact@myqrmenu.co",
        faqPrompt: "Oder sehen Sie sich unten unsere FAQs an, vielleicht finden Sie, wonach Sie suchen.",
    },

    FOOTER: {
        footerHeading: "Nahtlose digitale Menüs, vereinfacht!",
        footerButton: "Zur Warteliste hinzufügen",
        footerConnect: "Verbinden Sie sich mit uns",
        footerTerms: "Bedingungen und Vereinbarungen",
        footerHelp: "Hilfecenter",
        footerPrivacy: "Datenschutzrichtlinie",
        footerCopyright: `©${currentYear} Alle Rechte vorbehalten.`,
    },

    PRIVACY_POLICY: {
        title: "Datenschutz-Bestimmungen",
        lastUpdated: "Zuletzt aktualisiert: 22. Mai 2025",
        content: `
            <article class="mb-12">
                <p class="mb-6 leading-relaxed">
                Diese Datenschutzrichtlinie beschreibt unsere Richtlinien und Verfahren zur Erfassung, Verwendung und Offenlegung Ihrer Informationen, wenn Sie den Dienst nutzen.
                </p>
                <p class="mb-6 leading-relaxed">
                Wir verwenden Ihre personenbezogenen Daten zur Bereitstellung und Verbesserung des Dienstes. Durch die Nutzung des Dienstes erklären Sie sich mit der Erfassung und Nutzung von Informationen gemäß dieser Datenschutzrichtlinie einverstanden.
                </p>
            </article>

            <section class="mb-12">
                <header class="mb-6">
                <h2 class="text-2xl font-semibold">Interpretation und Definitionen</h2>
                </header>
                <article class="mb-8">
                <h3 class="text-xl font-semibold mb-2">Interpretation</h3>
                <p class="mb-6 leading-relaxed">
                    Wörter, deren Anfangsbuchstabe großgeschrieben ist, haben unter den folgenden Bedingungen definierte Bedeutungen.
                </p>
                </article>

                <article>
                <h3 class="text-xl font-semibold mb-4">Definitionen</h3>
                <ul class="list-disc list-inside mb-6 space-y-3 text-gray-800">
                    <li><strong>Konto</strong> bezeichnet ein einzigartiges Konto, das für Sie erstellt wurde, um auf unseren Dienst zuzugreifen.</li>
                    <li><strong>Unternehmen</strong> bezieht sich auf <strong>My QR Menu,</strong> London, Vereinigtes Königreich.</li>
                    <li><strong>Personenbezogene Daten</strong> sind alle Informationen, die sich auf eine identifizierte oder identifizierbare Person beziehen.</li>
                    <li><strong>Sie</strong> bezeichnet die Person, die auf den Dienst zugreift oder ihn nutzt.</li>
                </ul>
                </article>
            </section>

            <section class="mb-12">
                <h2 class="text-2xl font-semibold mb-6">Kontaktiere uns</h2>
                <p>
                Wenn Sie Fragen zu dieser Datenschutzrichtlinie haben, können Sie uns kontaktieren:
                </p>
                <ul class="list-disc list-inside mt-2">
                <li>Per E-Mail: <a href="mailto:hello@myqrmenu.co" class="text-gray-800 underline">hello@myqrmenu.co</a></li>
                </ul>
            </section>
        `
    },

    TERMS_AND_CONDITIONS: {
        title: "Allgemeine Geschäftsbedingungen",
        lastUpdated: "Zuletzt aktualisiert: 22. Mai 2025",
        content: `
            <p class="leading-relaxed mb-6">
            Bitte lesen Sie diese Allgemeinen Geschäftsbedingungen sorgfältig durch, bevor Sie unsere App oder Website nutzen.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">1. Interpretation und Definitionen</h2>
            <h3 class="text-xl font-semibold mt-6 mb-2">Interpretation</h3>
            <p class="leading-relaxed mb-4">
            Wörter, deren Anfangsbuchstabe großgeschrieben ist, haben unter den folgenden Bedingungen definierte Bedeutungen.
            </p>
            <h3 class="text-xl font-semibold mt-6 mb-2">Definitionen</h3>
            <ul class="list-disc list-inside mb-6 leading-relaxed text-gray-800">
            <li><strong>Anwendung</strong> bezeichnet die von My QR Menu bereitgestellte Software.</li>
            <li><strong>Unternehmen</strong> bezieht sich auf My QR Menu mit Sitz in London, UK.</li>
            <li><strong>Dienst</strong> bezieht sich auf die Anwendung und Website.</li>
            <li><strong>Sie</strong> bezeichnet die Person oder das Unternehmen, das auf den Dienst zugreift.</li>
            </ul>

            <h2 class="text-2xl font-semibold mt-10 mb-4">2. Anerkennung</h2>
            <p class="leading-relaxed mb-6">
            Durch den Zugriff auf den Dienst oder dessen Nutzung erklären Sie sich mit diesen Bedingungen einverstanden. Wenn Sie nicht einverstanden sind, dürfen Sie nicht auf den Dienst zugreifen.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">3. Links zu anderen Websites</h2>
            <p class="leading-relaxed mb-6">
            Unser Dienst kann Links zu Websites Dritter enthalten. Wir übernehmen keine Verantwortung für deren Inhalt oder Praktiken.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">4. Kündigung</h2>
            <p class="leading-relaxed mb-6">
            Wir behalten uns das Recht vor, Ihren Zugriff auf den Dienst unverzüglich und ohne Vorankündigung aus beliebigem Grund zu kündigen oder auszusetzen.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">5. Haftungsbeschränkung</h2>
            <p class="leading-relaxed mb-6">
            Soweit gesetzlich zulässig, haftet das Unternehmen nicht für Schäden, die aus Ihrer Nutzung des Dienstes resultieren.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">6. "WIE BESEHEN" und "WIE VERFÜGBAR" Haftungsausschluss</h2>
            <p class="leading-relaxed mb-6">
            Der Dienst wird Ihnen ohne Mängelgewähr zur Verfügung gestellt. Wir garantieren nicht, dass er fehlerfrei oder unterbrechungsfrei sein wird.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">7. Anwendbares Recht</h2>
            <p class="leading-relaxed mb-6">
            Diese Bedingungen unterliegen den Gesetzen des Vereinigten Königreichs.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">8. Streitbeilegung</h2>
            <p class="leading-relaxed mb-6">
            Im Falle von Streitigkeiten erklären Sie sich damit einverstanden, zunächst eine informelle Lösung zu suchen, bevor Sie rechtliche Schritte einleiten.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">9. Für Benutzer in der Europäischen Union (EU)</h2>
            <p class="leading-relaxed mb-6">
            Wenn Sie ein Verbraucher in der EU sind, genießen Sie den Schutz der zwingenden gesetzlichen Bestimmungen Ihres Wohnsitzlandes.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">10. Einhaltung gesetzlicher Vorschriften in den USA</h2>
            <p class="leading-relaxed mb-6">
            Sie sichern zu, dass Sie sich nicht in einem Land befinden, das US-Sanktionen unterliegt.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">11. Salvatorische Klausel und Verzicht</h2>
            <h3 class="text-xl font-semibold mt-6 mb-2">Salvatorische Klausel</h3>
            <p class="leading-relaxed mb-4">
            Sollte eine Bestimmung dieser Bedingungen unwirksam sein, bleiben die übrigen Bestimmungen in Kraft.
            </p>
            <h3 class="text-xl font-semibold mt-6 mb-2">Verzicht</h3>
            <p class="leading-relaxed mb-6">
            Die Nichtdurchsetzung einer Bestimmung stellt keinen Verzicht auf dieses Recht dar.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">12. Auslegung der Übersetzung</h2>
            <p class="leading-relaxed mb-6">
            Diese Bedingungen wurden möglicherweise übersetzt. Im Falle eines Konflikts ist die englische Fassung maßgebend.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">13. Änderungen dieser Bedingungen</h2>
            <p class="leading-relaxed mb-6">
            Wir können diese Bedingungen jederzeit aktualisieren. Wir werden Sie durch einen Hinweis auf unserer Website informieren.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">14. Kontaktieren Sie uns</h2>
            <p class="leading-relaxed mb-2">Wenn Sie Fragen zu diesen Bedingungen haben, können Sie uns kontaktieren:</p>
            <ul class="list-disc list-inside text-gray-800">
            <li>Per E-Mail: <a href="mailto:hello@myqrmenu.co" class="text-blue-600 underline">hello@myqrmenu.co</a></li>
            </ul>
        `
    }
};

export default locale;
